export default __webpack_public_path__ + "static/media/kurti-2.b4aead17.jpg";